// extracted by mini-css-extract-plugin
export var base = "_1q-0";
export var updateBanner = "_1q-1";